import Router from 'next/router'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {}

export const SignUpFlowModal = ({ isOpen, ...rest }: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '60px 50px 72px',
          width: '720px',
        },
      }}
      {...rest}
    >
      <h3 className="text-xl text-center text-[#404040] font-bold mb-[30px]">
        「サービス名」のお申し込み
      </h3>

      <div className="text-[17px] text-[#666666] px-[15px] leading-[30px] tracking-[0.42px]">
        アカウント登録後、専用アプリでログインいただくとすぐにサービスをご利用いただけます。
      </div>

      <div className="bg-[#EDF6F8] px-[30px] pt-[24px] pb-[22px] mt-[14px] ">
        <div className="text-center text-sm font-medium text-[#333333] mb-4">
          サービス開始までのステップ
        </div>
        <div className="flex flex-wrap justify-around my-auto">
          <div className="flex h-[81px] w-[124px] bg-white rounded-[4px]">
            <div className="block relative w-[18px] min-w-[18px] h-full text-[15px] text-white rounded-l-[4px] bg-[#79CAD3]">
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                1
              </span>
            </div>
            <div className="flex text-xs text-[#2DB9C4] text-left pt-[14px] pr-[6px] pb-[11px] pl-[8px]">
              アカウントの登録メールアドレス認証
            </div>
          </div>
          <div className="border-t-[9px] border-r-0 border-b-[9px] border-l-[10px] border-t-transparent border-r-transparent border-b-transparent border-l-[#2DB9C4] border-solid w-[10px] h-[18px] mt-auto mr-auto mb-auto ml-1" />
          <div className="flex h-[81px] w-[124px] bg-white rounded-[4px]">
            <div className="block relative w-[18px] min-w-[18px] h-full text-[15px] text-white rounded-l-[4px] bg-[#79CAD3]">
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                2
              </span>
            </div>
            <div className="flex text-xs text-[#2DB9C4] text-left pt-[14px] pr-[6px] pb-[11px] pl-[8px]">
              料金プランの選択とお支払い
            </div>
          </div>
          <div className="border-t-[9px] border-r-0 border-b-[9px] border-l-[10px] border-t-transparent border-r-transparent border-b-transparent border-l-[#2DB9C4] border-solid w-[10px] h-[18px] mt-auto mr-auto mb-auto ml-1" />
          <div className="flex h-[81px] w-[124px] bg-white rounded-[4px]">
            <div className="block relative w-[18px] min-w-[18px] h-full text-[15px] text-white rounded-l-[4px] bg-[#79CAD3]">
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                3
              </span>
            </div>
            <div className="flex text-xs text-[#2DB9C4] text-left pt-[14px] pr-[6px] pb-[11px] pl-[8px]">
              アカウントの登録完了
            </div>
          </div>
          <div className="border-t-[9px] border-r-0 border-b-[9px] border-l-[10px] border-t-transparent border-r-transparent border-b-transparent border-l-[#2DB9C4] border-solid w-[10px] h-[18px] mt-auto mr-auto mb-auto ml-1" />
          <div className="flex h-[81px] w-[124px] bg-white rounded-[4px]">
            <div className="block relative w-[18px] min-w-[18px] h-full text-[15px] text-white rounded-l-[4px] bg-[#79CAD3]">
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                4
              </span>
            </div>
            <div className="flex text-xs text-[#2DB9C4] text-left pt-[14px] pr-[6px] pb-[11px] pl-[8px]">
              専用アプリでログイン
            </div>
          </div>
        </div>
      </div>

      <button
        className="g-button g-button--primary w-[180px] mt-[37px] mx-auto block"
        onClick={() => Router.push('/web/agreement')}
      >
        はじめる
      </button>
    </Modal>
  )
}
